const CheckmarkBadgeIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_20_3891)">
        <path
          d="M11.0776 11.0832H11.0832M11.0776 11.0832C10.7144 11.4434 10.0561 11.3537 9.59447 11.3537C9.0278 11.3537 8.75492 11.4645 8.35051 11.8689C8.00614 12.2133 7.54451 12.8332 6.99985 12.8332C6.45518 12.8332 5.99354 12.2133 5.64917 11.8689C5.24475 11.4645 4.97187 11.3537 4.40521 11.3537C3.94357 11.3537 3.28528 11.4434 2.92204 11.0832C2.55589 10.7201 2.646 10.0591 2.646 9.59445C2.646 9.00733 2.5176 8.73735 2.09947 8.31924C1.4775 7.69728 1.16651 7.38626 1.1665 6.99982C1.16651 6.61338 1.47749 6.3024 2.09946 5.68043C2.4727 5.30719 2.646 4.93733 2.646 4.4052C2.646 3.94355 2.55629 3.28525 2.9165 2.92201C3.27959 2.55588 3.94061 2.64599 4.40522 2.64599C4.93733 2.64599 5.30719 2.47271 5.68043 2.09947C6.3024 1.47749 6.61339 1.1665 6.99984 1.1665C7.38628 1.1665 7.69727 1.47749 8.31925 2.09947C8.69241 2.47263 9.06219 2.64599 9.59446 2.64599C10.0561 2.64599 10.7144 2.55628 11.0777 2.9165C11.4438 3.27959 11.3537 3.9406 11.3537 4.4052C11.3537 4.99234 11.4821 5.26231 11.9002 5.68043C12.5222 6.3024 12.8332 6.61338 12.8332 6.99982C12.8332 7.38626 12.5222 7.69728 11.9002 8.31924C11.4821 8.73734 11.3537 9.00734 11.3537 9.59445C11.3537 10.0591 11.4438 10.7201 11.0776 11.0832Z"
          stroke="#A1A920"
        />
        <path
          d="M5.25 7.52067L6.3 8.45817L8.75 5.5415"
          stroke="#A1A920"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_20_3891">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckmarkBadgeIcon;
